import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
        // HACK: position=relative для возможности отображения элементов напротив заголовка секции.
        position: 'relative'
    },
    mainGutter: {
        marginBottom: theme.spacing(5),
    },
    subGutter: {
        marginBottom: theme.spacing(2),
    },
    title: {
        background: theme.palette.secondary.main,
        color: '#fff',
        padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
        marginBottom: theme.spacing(0.5),
        textTransform: 'uppercase',
        fontSize: '1.1rem',
        fontWeight: 600,
    }
}));
export default React.forwardRef((props, ref) => {
    const classes = useStyles();
    return (React.createElement("section", { id: props.id, ref: ref, className: `${classes.root} ${props.variant != 'sub' ? classes.mainGutter : classes.subGutter}` },
        props.title && (!props.variant || props.variant == 'main')
            ? React.createElement(Typography, { variant: "h4", component: "h2", className: classes.title }, props.title) : '',
        props.title && props.variant == 'sub'
            ? React.createElement(Typography, { variant: "h5", component: "h3", paragraph: true }, props.title) : '',
        props.children));
});
